import React, { useRef } from 'react';
import { Star } from 'lucide-react';
export function Reviews() {
  const scrollRef = useRef<HTMLDivElement>(null);
  const reviews = [{
    quote: 'These leggings are everything. The fit is perfect and they stay put through my entire Pilates class.',
    author: 'Sarah M.'
  }, {
    quote: 'Finally found activewear that looks as good off the mat as it does on. The quality is unmatched.',
    author: 'Emma K.'
  }, {
    quote: 'The fabric is so soft and supportive. I live in these pieces. Worth every penny.',
    author: 'Jessica L.'
  }];
  return <section className="py-16 md:py-24 px-6 bg-sand" data-id="element-131">
      <div className="max-w-7xl mx-auto" data-id="element-132">
        <h2 className="font-serif font-light text-3xl md:text-4xl text-espresso text-center mb-12" data-id="element-133">
          Loved by our community.
        </h2>

        <div ref={scrollRef} className="flex gap-6 overflow-x-auto pb-4 snap-x snap-mandatory scrollbar-hide md:grid md:grid-cols-3 md:overflow-visible" data-id="element-134">
          {reviews.map((review, idx) => <div key={idx} className="flex-shrink-0 w-[300px] md:w-auto snap-start bg-cream p-8 rounded-lg" data-id="element-135">
              <div className="flex gap-1 mb-4" data-id="element-136">
                {[...Array(5)].map((_, i) => <Star key={i} size={16} className="fill-rust text-rust" data-id="element-137" />)}
              </div>
              <p className="font-serif italic text-lg text-espresso mb-4 leading-relaxed" data-id="element-138">
                "{review.quote}"
              </p>
              <p className="text-sm uppercase tracking-widest text-espresso/70" data-id="element-139">
                {review.author}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}